export enum ServiceDetailRoutesPath {
  VEHICLE_VALUATION = 'vehicle-valuation',
  VEHICLE_SALE = 'vehicle-sale',
  VEHICLE_PURCHASE = 'vehicle-purchase',
  THEFT_DECLARATION = 'theft-declaration',
}
